import { render } from "./Privacy.vue?vue&type=template&id=0a26ac5a&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=0a26ac5a&scoped=true&lang=css"

import exportComponent from "/tmp/build_2d2f4584/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a26ac5a"]])

export default __exports__